import { render, staticRenderFns } from "./PerfilInfo.vue?vue&type=template&id=68d407b4&scoped=true"
import script from "./PerfilInfo.vue?vue&type=script&lang=js"
export * from "./PerfilInfo.vue?vue&type=script&lang=js"
import style0 from "./PerfilInfo.vue?vue&type=style&index=0&id=68d407b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d407b4",
  null
  
)

export default component.exports